import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import '../layout/Filter.Module.css';
import '../layout/Portifolio.Module.css';
import { news as originalNews } from '../noticias';
import { Link } from 'react-router-dom';
import translateText from './translateText';
import { useTranslation } from 'react-i18next';
import { useLanguage } from './LanguageContext';
import useScrollReveal from './hooks/useScrollReveal';
import axios from 'axios';
function Noticias() {
  useScrollReveal(true);
  useEffect(() =>{
    $(".list").on('click',function(e){
      $(".list").removeClass("active");
      $(this).addClass("active");
    })

    $('.list').on('click',function(){
      const value = $(this).attr('data-filter');
      if(value == 'all'){
        $('.news-card').show('1000');
      }
      else{
        $('.news-card').not('.'+value).hide('1000');
        $('.news-card').filter('.'+value).show('1000');
      }
    });
}, [])

const { t, i18n } = useTranslation('');
const { selectedLanguage } = useLanguage();  // Obtém o idioma atual
  return (
<div className='pag-noticias'>
<section id="gallery">
  
<h4 className='scroll-bottom'>{t('noticias.tituloPage')}</h4>
<h1 className='title_head scroll-top'>{t('homepage.titleNoticias')}</h1>

    <div className='filter-button scroll-right'>
        <ul>
          <li className='list active' data-filter="all">{t('navbar.tudo')}</li>
          <li className='list' data-filter="news">{t('homepage.titleNoticias')}</li>
          <li className='list' data-filter="recru">{t('noticias.recrutamento')}</li>
        </ul>
    </div> 

  <ul className="content-wrapper scroll-right">
  {originalNews.map((item, index) => (
            <li className={`news-card ${item.type}`} key={index}>
              <Link to={`/noticia/${item.id}`} className="news-card__link">
                <img src={item.imgP} width="100%" alt={item.title} className="news-card__image" />
                <div className="news-card__text-wrapper">
                  <h2 className="news-card__title">{item.title[selectedLanguage]}</h2>
                  <div className="news-card__post-date">{item.data}</div>
                  <div className="news-card__details-wrapper">
                    <p className="news-card__excerpt">{item.descri[selectedLanguage]}</p>
                    <span className="news-card__read-more">
                      {t('noticias.lermais')}<i className="fas fa-long-arrow-alt-right"></i>
                    </span>
                  </div>
                </div>
              </Link>
            </li>
          ))}

    <li className={`news-card recru`}>
            <Link to={`/candidatura-espontanea/`} className="news-card__link">
              <img src="../images/noticias/7/candidatura_espon.jpg" width="100%" alt="candidatura" className="news-card__image" />
              <div className="news-card__text-wrapper">
                <h2 className="news-card__title">{t('noticias.candida')}</h2>
                <div className="news-card__post-date"></div>
                <div className="news-card__details-wrapper">
                  <p className="news-card__excerpt">{t('recru.text')}</p>
                  <span className="news-card__read-more">
                    {t('noticias.lermais')}<i className="fas fa-long-arrow-alt-right"></i>
                  </span>
                </div>
              </div>
            </Link>
          </li>
     </ul>  

</section>
</div>
  )
}

export default Noticias